var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('div',{staticClass:"breadcrumb"},[_c('router-link',{attrs:{"to":{ name: 'page.home' }}},[_vm._v(_vm._s(_vm.$t('page_title_home')))]),_vm._v("\n    / "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }